import { useState } from 'react';
import ElementEntriesReport from './ElementEntriesReport';
import EmployeeMasterReport from './EmployeeMasterReport';
import AdpCatalogReports from './AdpCatalogReports';

export default function Reports({ connectionRefresh }) {
  const [oracleHint, setOracleHint] = useState('');
  const [masterHint, setMasterHint] = useState('');

  return (
    <div className="space-y-6">
      <header className="page-hero">
        <p className="section-title">Oracle HCM</p>
        <h2 className="mt-1 text-2xl font-bold tracking-tight text-slate-100">Reports</h2>
        <p className="mt-2 text-sm text-slate-400">
          Pull or upload Oracle analytics exports used by reconciliation. Saved files stay in
          this app and feed the matching checks automatically.
        </p>
      </header>

      <div className="card-panel p-5">
        <div className="mb-3">
          <h3 className="text-base font-semibold text-slate-100">Element Entries</h3>
          <p className="text-xs text-slate-500">
            Per-employee pay elements. Feeds <strong className="text-slate-300">Payroll Recon</strong>.
          </p>
        </div>
        <ElementEntriesReport
          connectionRefresh={connectionRefresh}
          onOracleReady={(data) => {
            setOracleHint(
              data.savedPath
                ? `Oracle file updated — ${data.rowCount?.toLocaleString()} rows saved. Run Payroll Recon to use it (or upload a different file on that page).`
                : ''
            );
          }}
        />
        {oracleHint && <p className="alert-success mt-4">{oracleHint}</p>}
      </div>

      <div className="card-panel p-5">
        <div className="mb-3">
          <h3 className="text-base font-semibold text-slate-100">Employee Master</h3>
          <p className="text-xs text-slate-500">
            One wide employee extract (personal, employment, banking, email). Feeds{' '}
            <strong className="text-slate-300">Demographic Recon</strong> and the{' '}
            <strong className="text-slate-300">Pre-Payroll</strong> Employment / Banking / Email
            checks.
          </p>
        </div>
        <EmployeeMasterReport
          connectionRefresh={connectionRefresh}
          onOracleReady={(data) => {
            setMasterHint(
              data.savedPath
                ? `Employee master saved — ${data.rowCount?.toLocaleString()} rows, ${data.columnCount} columns. Demographic Recon and the Pre-Payroll field checks will use it automatically when you don't upload a file.`
                : ''
            );
          }}
        />
        {masterHint && <p className="alert-success mt-4">{masterHint}</p>}
      </div>

      <AdpCatalogReports connectionRefresh={connectionRefresh} />
    </div>
  );
}
